/**
 * Stored template cells → the column_values object a create mutation takes,
 * through the mapping the apply resolved (idMap: template column id → board
 * column id; skipIds: columns the user chose to skip).
 *
 * Same rules both apply paths have always used:
 *   dropdown  → the text (with create_labels_if_missing the label is created)
 *   status    → { label: text }   ('color' is the legacy spelling)
 *   others    → JSON.parse(value), or the raw value when it is not JSON
 * A cell with no value (a date rule that could not resolve) is left out, and
 * so is an unsupported or unmapped column — never guessed into a column.
 */
import { canonicalType, isSupportedColumn } from '../Config';

export function composeColumnValues(cells, idMap, skipIds) {
  const out = {};
  for (const cv of cells || []) {
    if (!cv || !isSupportedColumn(cv.type)) continue;
    if (skipIds && skipIds.has(String(cv.id))) continue;
    const target = idMap ? idMap[String(cv.id)] : undefined;
    if (target === undefined) continue;
    switch (canonicalType(cv.type)) {
      case 'dropdown':
        out[target] = cv.text;
        break;
      case 'status':
        out[target] = { label: cv.text };
        break;
      default:
        if (cv.value === null || cv.value === undefined) break;
        try {
          out[target] = JSON.parse(cv.value);
        } catch (e) {
          out[target] = cv.value;
        }
    }
  }
  return out;
}
